import { StrategyTrigger } from '../../../core/model/central/strategy.model';

// TODO: Consider moving this as it might also be used for reminder report

export class TriggerOffset {
    daysBefore = 0;
    hoursBefore = 0;
    minutesBefore = 0;
    timeOfDay: Date = new Date();
    hoursOfDay = 0;
    minutesOfDay = 0;
    minTime: Date = new Date();
    maxTime: Date = new Date();

    constructor(trigger: StrategyTrigger) {
        if (trigger !== undefined) {
            this.offsetsToUIModel(trigger.relativeOffset, trigger.fixedOffset);
        }

        // TODO: Set these based on block times
        this.minTime.setHours(5);
        this.minTime.setMinutes(0);
        this.maxTime.setHours(23);
        this.maxTime.setMinutes(0);
    }

    setOffsetMode(trigger: StrategyTrigger, nextMode: string, currentMode: string): void {
        // Reset values not used for current mode - and set default values for the mode
        switch (nextMode) {

            case 'day':
                if (currentMode !== 'dayfixed') {
                    this.setDaysBefore(trigger, 1);
                }
                this.setHoursBefore(trigger, 0);
                this.setMinutesBefore(trigger, 0);
                this.timeOfDay = new Date();
                this.timeOfDay.setHours(0);
                this.timeOfDay.setMinutes(0);
                this.setTimeOfDay(trigger, this.timeOfDay);
                this.uiModelToOffsets(trigger);
                break;

            case 'dayfixed':
                if (currentMode !== 'day') {
                    this.setDaysBefore(trigger, 1);
                }
                this.setHoursBefore(trigger, 0);
                this.setMinutesBefore(trigger, 0);
                this.timeOfDay = new Date();
                this.timeOfDay.setHours(6);
                this.timeOfDay.setMinutes(0);
                this.setTimeOfDay(trigger, this.timeOfDay);
                this.uiModelToOffsets(trigger);
                break;

            case 'uponappointmentcreation':
                this.setDaysBefore(trigger, 0);
                this.setHoursBefore(trigger, 0);
                this.setMinutesBefore(trigger, 0);
                this.timeOfDay = new Date();
                this.timeOfDay.setHours(0);
                this.timeOfDay.setMinutes(0);
                this.setTimeOfDay(trigger, this.timeOfDay);
                this.uiModelToOffsets(trigger);
                break;

            case 'hours':
            default:
                this.setHoursBefore(trigger, 2);
                this.setDaysBefore(trigger, 0);
                break;

        }
    }

    offsetsToUIModel(relativeOffset, fixedOffset): void {
        let relativeOffsetMinutes = Math.floor(relativeOffset / (60 * 1000)) || 0;
        this.daysBefore = Math.floor(relativeOffsetMinutes / (60 * 24)) || 0;

        relativeOffsetMinutes -= this.daysBefore * 60 * 24;
        this.hoursBefore = this.daysBefore === 0
            ? Math.floor(relativeOffsetMinutes / 60) || 0
            : 0;

        this.minutesBefore = relativeOffsetMinutes - this.hoursBefore * 60;

        const fixedOffsetMinutes = Math.floor(fixedOffset / (60 * 1000)) || 0;
        this.hoursOfDay = Math.floor(fixedOffsetMinutes / 60) || 0;
        this.timeOfDay.setHours(this.hoursOfDay);
        this.minutesOfDay = fixedOffsetMinutes - this.hoursOfDay * 60 || 0;
        this.timeOfDay.setMinutes(this.minutesOfDay);
    }

    uiModelToOffsets(trigger: StrategyTrigger): void {
        trigger.fixedOffset = 0;
        trigger.relativeOffset = this.daysBefore > 0
            ? this.daysBefore * 24 * 60 * 60 * 1000
            : ((this.hoursBefore * 60) + this.minutesBefore) * 60 * 1000;
        trigger.fixedOffset = ((this.hoursOfDay * 60) + this.minutesOfDay) * 60 * 1000;
    }

    setDaysBefore(trigger: StrategyTrigger, days): void {
        this.daysBefore = days;
        this.clearTimeOfDayIfHoursOrMinutesBefore();
        this.uiModelToOffsets(trigger);
    }

    setHoursBefore(trigger: StrategyTrigger, hours): void {
        this.hoursBefore = hours;
        this.clearTimeOfDayIfHoursOrMinutesBefore();
        this.uiModelToOffsets(trigger);
    }

    clearTimeOfDayIfHoursOrMinutesBefore(): void {
        if (this.hoursBefore > 0 || this.minutesBefore > 0) {
            this.hoursOfDay = 0;
            this.minutesOfDay = 0;
        }
    }

    setMinutesBefore(trigger: StrategyTrigger, minutes): void {
        this.minutesBefore = minutes;
        this.uiModelToOffsets(trigger);
    }

    // TODO: Set timeOfDay based on current offset

    setTimeOfDay(trigger: StrategyTrigger, timeOfDay): boolean {
        const changed = this.hoursOfDay !== timeOfDay.getHours() || this.minutesOfDay !== timeOfDay.getMinutes();
        if (changed) {
            this.hoursOfDay = timeOfDay.getHours();
            this.minutesOfDay = timeOfDay.getMinutes();
            this.uiModelToOffsets(trigger);
        }

        return changed;
    }

    label(): string {
        // TODO: Cache the result to avoid recalculating if nothing changed (improve performance of e.g. trigger list)

        const time = this.printTimeOfDay();

        if (this.daysBefore === 0 && this.hoursBefore === 0 && this.minutesBefore === 0) {
            return `The day of the appointment${time}`;
        }

        const days = this.daysBefore === 0
            ? ''
            : this.daysBefore === 1
                ? `${this.daysBefore} day `
                : `${this.daysBefore} days `;

        const minutes = this.minutesBefore === 0
            ? ''
            : this.minutesBefore === 1
                ? `${this.minutesBefore} minute `
                : `${this.minutesBefore} minutes `;

        const hours = this.hoursBefore === 0
            ? ''
            : this.hoursBefore === 1
                ? `${this.hoursBefore} hour `
                : `${this.hoursBefore} hours `;

        const andMinutes = this.hoursBefore > 0 && this.minutesBefore > 0
            ? 'and '
            : '';

        return `${days}${hours}${andMinutes}${minutes} before appointment${time}`;
    }

    printTimeOfDay(): string {
        let time = '';
        if (this.hoursOfDay > 0 || this.minutesOfDay > 0) {
            let meridiem = 'AM';
            let hoursOfDay = this.hoursOfDay;
            if (this.hoursOfDay == 12) {
                hoursOfDay = this.hoursOfDay;
                meridiem = 'PM';
            }

            if (this.hoursOfDay > 12) {
                hoursOfDay = this.hoursOfDay - 12;
                meridiem = 'PM';
            }
            const minutesOfDay = this.minutesOfDay < 10
                ? `0${this.minutesOfDay}`
                : this.minutesOfDay;
            time = ` at ${hoursOfDay}:${minutesOfDay} ${meridiem}`;
        }

        return time;
    }
}
